const aboutUsAltTextI18nEn = {
  'altTextMonikaAboutUsImage': 'Dr. Monika Hauck founder Repair Rebels sustainable fashion',
  'altTextAboutUs2Image': 'Repair Rebels online fashion repair service',
};

export default aboutUsAltTextI18nEn;
